
import Pagination from "../shop/PaginationDefault.vue";
import { useStore } from "vuex";
import { computed, ComputedRef } from "@vue/runtime-core";
import { removeQueries, updateQuery } from "../../../utils/routing_utils";
import router from "@/routes";

export default {
  name: "CommentsModal",
  methods: { updateQuery },
  components: { Pagination },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const store = useStore();

    const commentsPage: ComputedRef<number> = computed(
      () => store.getters["course_module/commentsPage"]
    );

    const closeCommentsModal = async () => {
      await removeQueries(router, ["pageDefault", "courseID"]);
      await emit("closeCommentsModal");
    };

    return {
      commentsPage,
      closeCommentsModal
    };
  }
};
